import { createApi, createServices } from '@trading/core/src/controllers/bootstrap'

// Application composition root. Core services receive these dependencies explicitly.
export const api = createApi()
export const services = createServices(api)
